// src/components/Partners.js
import React from 'react';
import styles from '../css/Partners.module.css';

const Partners = () => {
  return (
    <div className={styles.partnerSection}>
      <div className={styles.container}>
        <p className={styles.label}>Yetkili Satış & Uygulama Bayisi</p>
        <div className={styles.logoRow}>
          <img 
            src="assets/img/michelin-logo.png" 
            alt="Michelin Yetkili Bayi" 
            className={styles.partnerLogo} 
          />
          {/* İleride başka bayilik alırsan yanına ekleyebilirsin 
          <div className={styles.divider}></div>*/}
        </div>
      </div>
    </div>
  );
};

export default Partners;